import { ConnectionManagerNetworkKeys as networkKeys } from '../../helpers/constants';
import DefaultForm from './DefaultForm';
import PigeonHoleForm from './PigeonHoleForm';

export default function formForNetwork(network) {
  switch (network?.type) {
    case networkKeys.PIGEON_HOLE:
      return PigeonHoleForm;
    default:
      return DefaultForm;
  }
}
